import yup from "../utility/ValidationUtilty";

export type Questionnaire = {
  messageId: string;
  target: string;
  subject: string;
  questionNumber: number;
  title1: string;
  answers1: string[];
  title2: string;
  answers2: string[];
  title3: string;
  answers3: string[];
  tenantId?: string;
  sendDate?: Date;
  eventAt?: Date;
};

export const QuestionnaireSchema = yup.object({
  // 対象者
  target: yup.string().required(),
  // 件名
  subject: yup.string().required(),
  // 質問1タイトル
  title1: yup.string().required(),
  // 回答1
  answers1: yup.array().of(
    yup.string().test('is-first-answer-required', '必ず入力してください。', function (value, context) {
      return context.path !== 'answers1[0]' || !!value;
    })
  ).min(1).required(),
  // 質問2タイトル
  title2: yup.string().when('questionNumber', {
    is: (questionNumber: number) => questionNumber >= 2,
    then: yup.string().required(),
    otherwise: yup.string().notRequired()
  }),
  // 質問2回答
  answers2: yup.array().when('questionNumber', {
    is: (questionNumber: number) => questionNumber >= 2,
    then: yup.array().of(
      yup.string().test('is-first-answer-required', '必ず入力してください。', function (value, context) {
        return context.path !== 'answers2[0]' || !!value;
      })
    ).min(1).required(),
    otherwise: yup.array().of(yup.string()).notRequired()
  }),
  // 質問3タイトル
  title3: yup.string().when('questionNumber', {
    is: (questionNumber: number) => questionNumber >= 3,
    then: yup.string().required(),
    otherwise: yup.string().notRequired()
  }),
  // 質問3回答
  answers3: yup.array().when('questionNumber', {
    is: (questionNumber: number) => questionNumber >= 3,
    then: yup.array().of(
      yup.string().test('is-first-answer-required', '必ず入力してください。', function (value, context) {
        return context.path !== 'answers3[0]' || !!value;
      })
    ).min(1).required(),
    otherwise: yup.array().of(yup.string()).notRequired()
  }),
});